import React from 'react';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import AuthenticationFlow from 'legacy/auth/components/authentication-flow/AuthenticationFlow';
import useAuthenticationStatus from 'legacy/common/hooks/useAuthenticationStatus';
import { useMultiTierCheckout } from '../../context';

import { StepProps, StepsId } from '../../types';

type Props = {
  goToStep: StepProps['goToStep'];
};

const GoToRequestScreeningButton = ({ goToStep }: Props) => {
  const {
    onAuthenticationSuccess,
    data: { requestScreening },
    onSuccess
  } = useMultiTierCheckout();
  const { isAuthenticated } = useAuthenticationStatus();

  const goToRequestScreening = () => {
    if (requestScreening.questions.length > 0) {
      goToStep(StepsId.RequestScreeningStep);
    } else {
      requestScreening.submitRequest({}).then(() => {
        onSuccess();
        goToStep(StepsId.SuccessRequestApprovalStep);
      });
    }
  };

  if (!isAuthenticated()) {
    return (
      <AuthenticationFlow onCompleteAuthentication={onAuthenticationSuccess}>
        {({ startAuthenticationFlow }) => (
          <Button onClick={startAuthenticationFlow} type={ButtonType.Primary}>
            Continue
          </Button>
        )}
      </AuthenticationFlow>
    );
  }

  return (
    <Button onClick={goToRequestScreening} type={ButtonType.Primary}>
      Request to join
    </Button>
  );
};

export default GoToRequestScreeningButton;
